'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { TipsenLink } from '../TipsenLink/entry.js';
import { useModalManager } from './ModalManagerProvider.js';
/**
 * Link for opening a modal query route while retaining its scroll origin.
 *
 * @param linkProps - link configuration and children
 * @returns modal-aware link
 */
export default function ModalLink(linkProps) {
    const { onClick, scroll: shouldScroll = false, ...props } = linkProps;
    const { prepareModalOpen } = useModalManager();
    const handleClick = (event) => {
        onClick?.(event);
        if (event.defaultPrevented ||
            event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey ||
            event.currentTarget.target === '_blank' ||
            event.currentTarget.hasAttribute('download')) {
            return;
        }
        prepareModalOpen(event.currentTarget);
    };
    return _jsx(TipsenLink, { ...props, scroll: shouldScroll, onClick: handleClick });
}
//# sourceMappingURL=ModalLink.js.map